var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAskForNetwork({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52496 11.0997C4.91945 11.0997 6.04991 9.96926 6.04991 8.57476C6.04991 7.18027 4.91945 6.0498 3.52496 6.0498C2.13046 6.0498 1 7.18027 1 8.57476C1 9.96926 2.13046 11.0997 3.52496 11.0997Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.941 14.4664C13.3355 14.4664 14.4659 13.336 14.4659 11.9415C14.4659 10.547 13.3355 9.4165 11.941 9.4165C10.5465 9.4165 9.41602 10.547 9.41602 11.9415C9.41602 13.336 10.5465 14.4664 11.941 14.4664Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.941 6.04991C13.3355 6.04991 14.4659 4.91945 14.4659 3.52496C14.4659 2.13046 13.3355 1 11.941 1C10.5465 1 9.41602 2.13046 9.41602 3.52496C9.41602 4.91945 10.5465 6.04991 11.941 6.04991Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68359 7.27891L9.77964 4.82129",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86914 9.51172L9.59934 11.0042",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAskForNetwork);
export default __webpack_public_path__ + "static/media/AskForNetwork.e1e39917c492166467dfbc506a4d6322.svg";
export { ForwardRef as ReactComponent };